import React from 'react';
import './Features.css';

const services = [
  {
    number: '01',
    title: 'AI Strategy',
    description: 'We assess the current state, identify high-impact opportunities, and build a clear AI roadmap aligned with each client\'s business goals.',
  },
  {
    number: '02',
    title: 'Custom Model Development',
    description: 'Fine-tuned and purpose-built models trained on your data, designed to solve your specific problems with precision and accuracy.',
  },
  {
    number: '03',
    title: 'Integration',
    description: 'We connect AI capabilities into existing workflows, tools, and systems — without disrupting what already works.',
  },
  {
    number: '04',
    title: 'AI Adoption',
    description: 'We maximize the return on our clients\' AI investment — aligning workflows, enabling teams, and continuously optimizing for measurable business impact.',
  },
];

function Features() {
  return (
    <section className="services section" id="services">
      <div className="container">
        <div className="section-header">
          <p className="section-label"><span className="section-prompt">&gt;</span> Services</p>
          <h2 className="section-title">How we work</h2>
          <p className="section-subtitle">
            From strategy to implementation, we partner with our clients at every stage of their AI journey.
          </p>
        </div>
        <div className="services-grid">
          {services.map((service) => (
            <div key={service.number} className="service-card">
              <div className="service-card-header">
                <span className="service-number">{service.number}</span>
              </div>
              <div className="service-card-body">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
